/**
 * Copies a URL to the clipboard and returns a success status
 * @param {string} url - The URL to copy to clipboard
 * @returns {Promise<boolean>} - True if successful, false otherwise
 */
export const copyToClipboard = async (url) => {
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch (err) {
    console.error('Failed to copy URL: ', err);
    return false;
  }
};

/**
 * Opens WhatsApp with a pre-filled message containing the document URL
 * @param {string} url - The document URL to share
 * @param {string|Object} title - The document title or the document object containing title and other properties
 * @param {Object} [options] - Additional options
 * @param {string} [options.sending_text] - Custom text to use for the message
 * @param {boolean} [options.sendable] - Whether the document is allowed to be sent
 */
export const shareOnWhatsApp = (url, title, { sending_text, sendable = true } = {}) => {
  // If sendable is explicitly false, don't proceed with sharing
  if (sendable === false) {
    console.log('Sharing is disabled for this document');
    return;
  }
  
  // Use custom sending_text if provided, otherwise fall back to default message
  const message = sending_text 
    ? `${sending_text}\n\n${url}`
    : `Check out this document: ${typeof title === 'string' ? title : (title?.title || 'Document')}\n\n${url}`;
    
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, '_blank');
};
